const addSeparatorMixin = {
  filters: {
    addSeparator(value) {
      let num = Number(value);
      if (value === null || value === '' || Number.isNaN(num)) {
        return value;
      }
      return Number(parseFloat(value).toFixed(2)).toLocaleString('en', {
        minimumFractionDigits: 2
      });
    }
  }
};

const formatDateMixin = {
  filters: {
    formatDate(value) {
      if (value == '') {
        return value;
      }
      const date = new Date(value);
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}.`;
    },
    formatDateTime(value) {
      if (!value || value == '') {
        return '';
      }

      const datetime = value.split(' ');
      const date = new Date(datetime[0]);
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}. ${
        datetime[1]
      }`;
    }
  }
};

const formatDateNoSecondsMixin = {
  filters: {
    formatDateTimeNoSeconds(value) {
      if (!value || value == '') {
        return '';
      }

      var myDate = new Date(value);
      const dayOfMonth = ('0' + myDate.getDate()).slice(-2);
      const month = ('0' + (myDate.getMonth() + 1)).slice(-2);
      const hour = ('0' + myDate.getHours()).slice(-2);
      const minutes = ('0' + myDate.getMinutes()).slice(-2);
      const seconds = ('0' + myDate.getSeconds()).slice(-2);

      const dateFormatted = `${dayOfMonth}.${month}.${myDate.getFullYear()}. ${hour}:${minutes}`;
      return dateFormatted;
    }
  }
};

const formatEmptyFieldsMixin = {
  filters: {
    formatEmptyFields(value) {
      if (!value || value == '') {
        return '/';
      }
      return value;
    }
  }
};

const formatDivDescriptionMixin = {
  filters: {
    formatDivDescription(divDesc) {
      if (divDesc) {
        if (divDesc.toLowerCase().startsWith('lok')) {
          return divDesc;
        } else {
          return 'Stan ' + divDesc;
        }
      } else {
        return 'Upravnik';
      }
    }
  }
};
export {
  addSeparatorMixin,
  formatDateMixin,
  formatDateNoSecondsMixin,
  formatEmptyFieldsMixin,
  formatDivDescriptionMixin
};
